module.exports = __webpack_public_path__ + "img/eucerin.210e7b77.png";